import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ReactComponent as LinkIcon } from 'assets/figma-icons/Link.svg'
import { Flex, Text, Spacer } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'
import Progress from 'components/global/ds/Progress'
import Frame from 'components/global/templates/RequestDrawer/ds/Frame'
import { Trans } from 'react-i18next'
import { format } from 'utils/date'
import { startOfYear, endOfYear } from 'date-fns'

import styles from './styles.module.css'
import { formatMonth } from '../helper'

const Balance = ({ available, used, to, navigation, isPast }) => {
  if (!available && available !== 0) return null

  const startDate = new Date(startOfYear(new Date()))
  const endDate = new Date(endOfYear(new Date()))
  const progress = 100 - (Math.max(0, used) * 100) / Math.max(0, available)
  return (
    <Frame
      title={I18n.t('balance')}
      titleSuffix={
        navigation && (
          <Link
            to={navigation}
            target="_blank"
          >
            <LinkIcon />
          </Link>
        )
      }
      description={`${format(startDate, `dd ${formatMonth} yyyy`)} - ${format(
        endDate,
        `dd ${formatMonth} yyyy`,
      )}`}
    >
      <>
        <Flex justifyBetween>
          <Flex itemsCenter>
            <div className={styles.availableCircle} />
            <Spacer width={8} />
            <Text
              typography="paragraph14"
              color="#51516b"
            >
              {I18n.t('available_to_use')}
            </Text>
          </Flex>
          <Flex itemsCenter>
            <div className={styles.UsedCircle} />
            <Spacer width={8} />
            <Text
              typography="paragraph14"
              color="#51516b"
            >
              {I18n.t('used')}
            </Text>
          </Flex>
        </Flex>
        <Flex justifyBetween>
          <Text typography="subtitle">
            {I18n.t('days_number', { number: Math.floor(available) })}
          </Text>
          <Text typography="subtitle">{I18n.t('days_number', { number: Math.floor(used) })}</Text>
        </Flex>
        <Spacer height={8} />
        <Progress number={available < 0 ? 0 : progress} />
        {to && (
          <>
            <Spacer height={16} />
            <Flex className={styles.contentTexr}>
              <Spacer width={8} />
              <Text
                className={styles.dot}
                typography="paragraph14"
                color="#06062b99"
              >
                <Trans
                  i18nKey={isPast ? 'available_to_use_up' : 'this_balance_is_what_will_be'}
                  components={{
                    Text: (
                      <Text
                        as="span"
                        typography="paragraph14"
                        weight="bold"
                        color="#06062b99"
                      />
                    ),
                  }}
                  values={{ date: format(new Date(to), 'dd MMM, yyyy') }}
                />
              </Text>
            </Flex>
          </>
        )}
      </>
    </Frame>
  )
}

Balance.propTypes = {
  available: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  used: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.string,
  navigation: PropTypes.string,
  isPast: PropTypes.bool,
}

export default Balance
